// extracted by mini-css-extract-plugin
module.exports = {"container":"Future_container__2b7pD","card":"Future_card__39GYC","demo":"Future_demo__ZqPip","cases":"Future_cases__2mV86"};